/* UNDENIABLE — chrome behaviors (header, announcement, search, mobile nav, reveal, brackets).
   Ported from the source prototype; product/cart SPA logic removed (Shopify handles those). */
(function () {
  'use strict';
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion:reduce)').matches : false;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var pad = function (n) { return ('0' + n).slice(-2); };

  /* ── corner brackets ── */
  function brackets(root) {
    $$('[data-br]', root || document).forEach(function (el) {
      if (el.dataset.bd) return; el.dataset.bd = 1;
      ['c-tl', 'c-tr', 'c-bl', 'c-br'].forEach(function (p) {
        var s = document.createElement('span'); s.className = 'crn ' + p; el.appendChild(s);
      });
    });
  }

  /* ── collection facets: auto-submit the filter/sort form on change ── */
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets]');
    if (form && (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT')) form.submit();
  });

  /* ── reveal on scroll ── */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (e) {
    e.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
  }, { rootMargin: '0px 0px -4% 0px', threshold: 0.06 }) : null;
  function watch(r) {
    $$('[data-r]', r || document).forEach(function (el, i) {
      if (el.dataset.w) return; el.dataset.w = 1;
      el.style.transitionDelay = (i % 4 * 70) + 'ms';
      io ? io.observe(el) : el.classList.add('in');
    });
  }

  /* ── overlay / drawers lock ── */
  var ovl = $('#ovl');
  /* Portal the mobile nav + its overlay to <body> so a position:fixed drawer can never be
     trapped inside the header's stacking context (fixes the menu flashing behind content). */
  var _mnav = $('#mnav');
  if (_mnav && _mnav.parentElement !== document.body) document.body.appendChild(_mnav);
  if (ovl && ovl.parentElement !== document.body) document.body.appendChild(ovl);
  function openD(el) {
    if (!el) return;
    el.classList.add('on'); if (ovl) ovl.classList.add('on'); document.body.classList.add('lock');
    if (el.id === 'mnav') { var b = $('#burger'); if (b) b.setAttribute('aria-expanded', 'true'); }
  }
  function shut() {
    $$('.drw').forEach(function (d) { d.classList.remove('on'); });
    var mnav = $('#mnav'); if (mnav) mnav.classList.remove('on');
    var b = $('#burger'); if (b) b.setAttribute('aria-expanded', 'false');
    if (ovl) ovl.classList.remove('on'); document.body.classList.remove('lock');
  }
  if (ovl) ovl.onclick = shut;

  /* ── announcement: rotate + countdown ── */
  /* rotate all messages; the countdown message only joins the rotation on mobile (≤820px) */
  var annMobile = window.matchMedia && window.matchMedia('(max-width: 820px)').matches;
  var ms = $$('.ann__m').filter(function (m) { return annMobile || !m.classList.contains('ann__m--cd'); }), ai = 0;
  /* park every announcement message off-stage first so none can stack, then reveal the first */
  $$('.ann__m').forEach(function (m) { m.style.transform = 'translateY(100%)'; m.style.opacity = '0'; });
  ms.forEach(function (m, i) { m.style.transform = 'translateY(' + (i ? 100 : 0) + '%)'; m.style.opacity = i ? 0 : 1; });
  if (ms.length > 1) setInterval(function () {
    var a = ms[ai], b = ms[(ai + 1) % ms.length];
    b.style.transform = 'translateY(100%)'; b.style.opacity = '1';
    requestAnimationFrame(function () {
      a.style.transform = 'translateY(-100%)'; a.style.opacity = '0'; b.style.transform = 'translateY(0)';
    });
    ai = (ai + 1) % ms.length;
  }, 4200);

  var cd = $('#annCd'), cdRot = $('#annCdRot');
  if (cd || cdRot) {
    var src = cd || cdRot;
    var attr = (src.getAttribute('data-end') || '').trim();
    var end = attr ? Date.parse(attr.replace(' ', 'T')) : NaN;
    if (isNaN(end)) end = Date.now() + ((2 * 24 + 7) * 3600 + 42 * 60 + 11) * 1000;
    var tickCd = function () {
      var d = Math.max(0, end - Date.now());
      var t = pad(Math.floor(d / 864e5)) + ':' + pad(Math.floor(d % 864e5 / 36e5)) + ':' + pad(Math.floor(d % 36e5 / 6e4)) + ':' + pad(Math.floor(d % 6e4 / 1e3));
      if (cd) cd.textContent = t;
      if (cdRot) cdRot.textContent = t;
    };
    tickCd();
    setInterval(tickCd, 1000);
  }

  /* ── sale band countdown (#cD/#cH/#cM/#cS) ── */
  var saleEl = $('[data-sale-countdown]');
  if (saleEl) {
    var sAttr = (saleEl.getAttribute('data-end') || '').trim();
    var sEnd = sAttr ? Date.parse(sAttr.replace(' ', 'T')) : NaN;
    if (isNaN(sEnd)) sEnd = Date.now() + ((2 * 24 + 7) * 3600 + 42 * 60 + 11) * 1000;
    var setEl = function (id, val) { var e = document.getElementById(id); if (e) e.textContent = val; };
    var tickSale = function () {
      var d = Math.max(0, sEnd - Date.now());
      setEl('cD', pad(Math.floor(d / 864e5)));
      setEl('cH', pad(Math.floor(d % 864e5 / 36e5)));
      setEl('cM', pad(Math.floor(d % 36e5 / 6e4)));
      setEl('cS', pad(Math.floor(d % 6e4 / 1e3)));
    };
    tickSale();
    setInterval(tickSale, 1000);
  }

  /* ── mega menus (desktop hover) ── */
  var hdr = $('#hdr'), mt;
  if (hdr) {
    $$('[data-mega]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        clearTimeout(mt);
        $$('.mega').forEach(function (m) { m.classList.remove('on'); });
        var t = $('#' + a.dataset.mega); if (t) t.classList.add('on');
      });
    });
    hdr.addEventListener('mouseleave', function () { mt = setTimeout(function () { $$('.mega').forEach(function (m) { m.classList.remove('on'); }); }, 150); });
    hdr.addEventListener('mouseenter', function () { clearTimeout(mt); });
    $$('.mega a').forEach(function (a) { a.addEventListener('click', function () { $$('.mega').forEach(function (m) { m.classList.remove('on'); }); }); });
  }

  /* ── mobile nav ── */
  var burger = $('#burger');
  if (burger) burger.onclick = function () { $('#mnav').classList.contains('on') ? shut() : openD($('#mnav')); };
  var mnavX = $('#mnavX'); if (mnavX) mnavX.onclick = shut;
  $$('#mnav a').forEach(function (a) { if (a.classList.contains('mng__t') || a.closest('.mng__p')) a.addEventListener('click', shut); });
  /* mobile accordion groups (exact source behavior) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mng]'); if (!b) return;
    var g = b.closest('.mng'), p = $('.mng__p', g), open = g.classList.contains('on');
    $$('.mng.on', g.parentElement).forEach(function (o) { if (o !== g) { o.classList.remove('on'); var op = $('.mng__p', o); if (op) op.style.height = '0px'; } });
    if (open) { p.style.height = p.scrollHeight + 'px'; requestAnimationFrame(function () { g.classList.remove('on'); p.style.height = '0px'; }); }
    else { g.classList.add('on'); p.style.height = 'auto'; var h = p.scrollHeight; p.style.height = '0px'; requestAnimationFrame(function () { p.style.height = h + 'px'; }); }
  });

  /* ── search overlay ── */
  function openSrch() {
    var s = $('#srch'); if (!s) return;
    s.classList.add('on'); document.body.classList.add('lock');
    suggest('');
    setTimeout(function () { var i = $('#srchI'); if (i) i.focus(); }, 140);
  }
  function closeSrch() { var s = $('#srch'); if (s) s.classList.remove('on'); document.body.classList.remove('lock'); }
  var searchBtn = $('#searchBtn'); if (searchBtn) searchBtn.onclick = openSrch;
  var mnavSrch = $('#mnavSrch'); if (mnavSrch) mnavSrch.onclick = function () { shut(); setTimeout(openSrch, 260); };
  var srchX = $('#srchX'); if (srchX) srchX.onclick = closeSrch;
  var srch = $('#srch'); if (srch) srch.addEventListener('click', function (e) { if (e.target === srch) closeSrch(); });
  $$('.srch__t button').forEach(function (b) { b.onclick = function () { var i = $('#srchI'); if (i) { i.value = b.textContent; suggest(b.textContent); } }; });

  /* live predictive search via Shopify /search/suggest.json */
  var sT, srchI = $('#srchI');
  if (srchI) srchI.addEventListener('input', function () { clearTimeout(sT); var q = this.value; sT = setTimeout(function () { suggest(q); }, 220); });
  function money(cents) { try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); } catch (e) { return ''; } }
  function suggest(q) {
    var box = $('#srchR'); if (!box) return;
    if (!q) { box.innerHTML = ''; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) { box.innerHTML = '<p class="p" style="grid-column:1/-1">No matches for “' + q + '”.</p>'; return; }
        box.innerHTML = items.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || (p.image) || '';
          var src = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=360') : '';
          return '<article class="pc">' +
            '<div class="pc__m" data-br>' +
              (src ? '<img src="' + src + '" alt="' + (p.title || '') + '" loading="lazy" data-main>' : '') +
              '<a class="pc__lk" href="' + p.url + '" aria-label="' + (p.title || '') + '"></a>' +
            '</div>' +
            '<div class="pc__b"><div class="pc__top">' +
              '<a class="pc__n" href="' + p.url + '">' + (p.title || '') + '</a>' +
              '<span class="pc__price"><b>' + (p.price || '') + '</b></span>' +
            '</div></div></article>';
        }).join('');
      })
      .catch(function () { box.innerHTML = ''; });
  }

  /* ── escape closes everything ── */
  addEventListener('keydown', function (e) { if (e.key === 'Escape') { shut(); closeSrch(); } });

  /* ── newsletter feedback (native Shopify form still posts) ── */

  /* ── accordion (FAQ + product page) ── */
  function accOpen(it) {
    var a = it.querySelector('.acc__a'), q = it.querySelector('.acc__q');
    it.classList.add('on'); if (q) q.setAttribute('aria-expanded', 'true');
    a.style.height = 'auto'; var h = a.scrollHeight; if (!h) return;
    a.style.height = '0px';
    requestAnimationFrame(function () { a.style.height = h + 'px'; });
    a.addEventListener('transitionend', function te(ev) {
      if (ev.propertyName !== 'height') return; a.removeEventListener('transitionend', te);
      if (it.classList.contains('on')) a.style.height = 'auto';
    });
  }
  function accShut(it) {
    var a = it.querySelector('.acc__a'), q = it.querySelector('.acc__q');
    a.style.height = a.scrollHeight + 'px';
    requestAnimationFrame(function () { it.classList.remove('on'); if (q) q.setAttribute('aria-expanded', 'false'); a.style.height = '0px'; });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.acc__q'); if (!q) return;
    var it = q.closest('.acc__i'), open = it.classList.contains('on');
    $$('.acc__i.on', it.parentElement).forEach(function (o) { if (o !== it) accShut(o); });
    open ? accShut(it) : accOpen(it);
  });

  /* ── review marquees ── */
  var lanes = [];
  function measureLanes() { lanes.forEach(function (l) { l.w = l.el.scrollWidth / 2; }); }
  $$('.rvw__t').forEach(function (el) {
    var dir = +(el.getAttribute('data-dir') || 1);
    lanes.push({ el: el, x: dir < 0 ? 0 : -el.scrollWidth / 2, d: dir, s: +(el.getAttribute('data-speed') || 0.4), w: 0 });
  });
  measureLanes();
  if (!RM && lanes.length) (function loop() {
    lanes.forEach(function (l) {
      l.x -= l.s * l.d;
      if (l.w) { if (l.x <= -l.w) l.x += l.w; if (l.x > 0) l.x -= l.w; }
      l.el.style.transform = 'translate3d(' + l.x + 'px,0,0)';
    });
    requestAnimationFrame(loop);
  })();
  addEventListener('resize', measureLanes);
  addEventListener('load', measureLanes);
  [200, 800, 1600, 3000].forEach(function (ms) { setTimeout(measureLanes, ms); });

  /* ── sticky header: add a subtle shadow once scrolled (works whether the
     document or Horizon's .page-wrapper is the scroll container) ── */
  var stickyHdr = document.querySelector('.hdr-sticky');
  if (stickyHdr) {
    var pw = document.querySelector('.page-wrapper');
    /* subtle shadow once scrolled */
    var lastState = null;
    var onScroll = function () {
      var y = (pw && pw.scrollTop) || window.pageYOffset || document.documentElement.scrollTop || 0;
      var s = y > 6;
      if (s !== lastState) { lastState = s; stickyHdr.classList.toggle('scrolled', s); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── boot ── */
  function boot() {
    brackets(); watch();
    var hero = document.getElementById('hero');
    if (hero) requestAnimationFrame(function () { hero.classList.add('go'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* re-run in Shopify theme editor when sections reload */
  document.addEventListener('shopify:section:load', function () { brackets(); watch(); });
})();
